module.exports = __webpack_public_path__ + "static/media/beep-bop.5cf652c0.mp3";